import React from "react";
import "./Carousel.css"; // Import CSS for styling

const Carousel = () => {
  return (
    <div
      id="carouselExample"
      className="carousel slide"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div className="carousel-overlay">
            <img
              src="/outside1.jpg"
              className="d-block w-100 carousel-img"
              alt="Slide 1"
            />
            <div className="carousel-caption">
              <h2>
                <span
                  className="text-danger"
                  style={{ textDecoration: "underline" }}
                >
                  Sati
                </span>{" "}
                Industries
              </h2>

              <p>
                Delivering excellence with every product, we take pride in
                offering top-quality solutions that meet industry standards. Our
                commitment to innovation, reliability, and customer satisfaction
                ensures that we provide the best products tailored to your
                needs.
              </p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="carousel-overlay">
            <img
              src="/outside2.jpg"
              className="d-block w-100 carousel-img"
              alt="Slide 2"
            />
            <div className="carousel-caption">
              <h2>
                Trusted Name Since <span className="text-danger">1997</span>
              </h2>
              <p>
                Backed by over two decades of experience, Sati Multiplast has
                built a reputation for quick and efficient service. Our team
                blends rich industry knowledge, technical skills, and
                cutting-edge technology to consistently deliver top-grade
                plastic films, bags, and printed products that exceed customer
                expectations.
              </p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <div className="carousel-overlay">
            <img
              src="/office.jpg"
              className="d-block w-100 carousel-img"
              alt="Slide 3"
            />
            <div className="carousel-caption">
              <h2>
                Committed to{" "}
                <span className="text-danger"> Innovation and Excellence</span>
              </h2>
              <p>
                Driven by values of integrity, reliability, and continuous
                improvement, Sati Multiplast strives to lead the plastic
                conversion industry. Our focus on quality, technological
                advancement, and professional development enables us to serve
                both local and international markets with exceptional products
                and services.
              </p>
            </div>
          </div>
        </div>
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
